import AdDisplayInner from './AdDisplayInner';

export default AdDisplayInner;
